<template>
  <Row>
    <Col span="24"
      ><p class="kanbanDes">
        <label>作业车辆</label><span>{{ carNum }}台</span><label>作业线路</label
        ><span>{{ routeNum }}条</span>
      </p></Col
    >
    <Col
      span="24"
      style="text-align: center; margin-bottom: 20px; margin-top: 20px"
    >
      <i-circle
        :percent="attdRate"
        :size="120"
        :trail-width="10"
        trail-color="#163358"
        :stroke-width="10"
        stroke-color="#e1da19"
      >
        <p style="font-size: 28px; margin-bottom: 10px; color: #e1da19">
          {{ attdRate }}
        </p>
        <p style="color: #e1da19">完成率/%</p>
      </i-circle>
    </Col>
    <Col span="24">
      <Row style="text-align: center">
        <Col span="8"
          ><h2 class="wecwlet">{{ total }}</h2>
          <p>应巡查点</p></Col
        >
        <Col span="8">
          <h2 class="wecwlet">{{ onLine }}</h2>
          <p>已巡查点</p>
        </Col>
        <Col span="8">
          <h2 class="wecwlet">{{ duration }}</h2>
          <p>未巡查点</p>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      onLine: 0,
      duration: 0,
      total: 0,
      item: {},
      attdRate: 0,
      carNum: 0,
      routeNum: 0,
    };
  },
  methods: {
    zaixianlv(t) {
      var x;
      var d = (t / this.total) * 100;
      x = d.toFixed(2);
      return x;
    },
    getData() {
      axios({
        method: "post",
        url: axios.upf + "/screen/countAttd/gcCar",
        data: this.item,
      }).then((res) => {
        var data = res.data.data;
        this.onLine = data.actualCollect;
        this.duration = data.notCollect;
        this.total = data.mustCollect;
        this.attdRate = data.finishRate;
        this.routeNum = data.routeNum;
        this.carNum = data.carNum;
      });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style lang="">
h2.wecwlet {
  font-size: 20px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/xunchache.vue